module.exports = "<router-outlet></router-outlet>\n\n<!-- the overlay modal element -->\n<div class=\"md-overlay\"></div>\n<!-- <ngb-modal-backdrop *ngIf=\"backdrop\" class=\"modal-backdrop fade show\"></ngb-modal-backdrop> -->\n<!-- End of eoverlay modal -->\n<div class=\"modal-backdrop-custom\" style=\"color:white\" *ngIf=\"backdrop\"></div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ldt/Desktop/afropay_admin/afropay-admin-frontend/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main